import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    SITE_BUILDER_AI: 'Criador de Sites com IA',
  },
  ACTION: {
    CREATE_WITH_GOOGLE_MY_BUSINESS: 'Clique no Botão - Continuar',
    CREATE_WITH_YOUR_IDEAS: 'Clique no Botão - Continuar',
    CREATE_FROM_TEMPLATE: 'Clique no Botão - Continuar',
    CLICK_BUTTON_CONTINUE: 'Clique no Botão - Continuar',
    CLICK_BUTTON_BACK: 'Clique no Botão - Voltar',
    CREATE_MY_SITE: 'Clique no Botão - Criar meu site',
    CLICK_BUTTON_GO_BACK_AND_CHOOSE_ANOTHER_OPTION: 'Clique no Botão - Volte e escolha outra opção',
    CLICK_ON_BUTTON_NEXT_STEP: 'Clique no Botão - Próximo passo',
    CLICK_ON_BUTTON_CREATE_MY_SITE_NOW: 'Clique no Botão - Criar meu site agora',
    CLICK_ON_TEMPLATE: 'Clique no Template',
    CLICK_BUTTON_CREATE_WITH_THIS_TEMPLATE: 'Clique no Botão - Criar com esse template',
    CLICK_BUTTON_I_WANT_THIS_TEMPLATE: 'Clique no Botão - Quero este modelo',
    CLICK_BUTTON_SEARCH_FOR_ANOTHER: 'Clique no Botão - Procurar por outro',
    CLICK_BUTTON_SHOW_PREVIEW: 'Clique no Botão - Mostrar prévia',
  },
  LABEL: {
    CREATE_WITH_GOOGLE_MY_BUSINESS: 'Criar com Google meu Negócio',
    CREATE_WITH_YOUR_IDEAS: 'Criar com suas ideias',
    CREATE_FROM_TEMPLATE: 'Criar a partir de um modelo pronto',
    CREATION_METHOD_SELECTION: 'Seleção da forma de criação',
    STEP_1_SITE_NAME: 'Criar com suas ideias - Etapa 1 - Nome do Site',
    STEP_2_SEGMENT: 'Criar com suas ideias - Etapa 2 - Segmento',
    STEP_3_INFORMATION: 'Criar com suas ideias - Etapa 3 - Informações',
    CREATE_FROM_A_READY_MADE_TEMPLATE: 'Criar a partir de um modelo pronto',
  },
};

const events = {
  clickCreateWithMyBusiness: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_CONTINUE,
    label: EVENT.LABEL.CREATE_WITH_GOOGLE_MY_BUSINESS,
  },
  clickCreateWithYourIdeas: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_CONTINUE,
    label: EVENT.LABEL.CREATE_WITH_YOUR_IDEAS,
  },
  clickCreateFromTemplate: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_CONTINUE,
    label: EVENT.LABEL.CREATE_FROM_TEMPLATE,
  },
  clickGoBackMethodSelection: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_BACK,
    label: EVENT.LABEL.CREATION_METHOD_SELECTION,
  },
  clickCreateMySite: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CREATE_MY_SITE,
    label: EVENT.LABEL.CREATE_WITH_GOOGLE_MY_BUSINESS,
  },
  clickGoBackChooseAnotherOption: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_GO_BACK_AND_CHOOSE_ANOTHER_OPTION,
    label: EVENT.LABEL.CREATE_WITH_GOOGLE_MY_BUSINESS,
  },
  clickGoBackCreateWithMyBusiness: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_BACK,
    label: EVENT.LABEL.CREATE_WITH_GOOGLE_MY_BUSINESS,
  },
  clickNextStepStep1: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_ON_BUTTON_NEXT_STEP,
    label: EVENT.LABEL.STEP_1_SITE_NAME,
  },
  clickNextStepStep2: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_ON_BUTTON_NEXT_STEP,
    label: EVENT.LABEL.STEP_2_SEGMENT,
  },
  clickNextStepStep3: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_ON_BUTTON_CREATE_MY_SITE_NOW,
    label: EVENT.LABEL.STEP_3_INFORMATION,
  },
  clickCreateWithThisTemplate: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_CREATE_WITH_THIS_TEMPLATE,
    label: EVENT.LABEL.CREATE_FROM_A_READY_MADE_TEMPLATE,
  },
  clickIWantThisTemplate: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_I_WANT_THIS_TEMPLATE,
    label: EVENT.LABEL.CREATE_FROM_A_READY_MADE_TEMPLATE,
  },
  clickSearchForAnother: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_SEARCH_FOR_ANOTHER,
    label: EVENT.LABEL.CREATE_FROM_A_READY_MADE_TEMPLATE,
  },
  clickShowPreview: {
    campaign: EVENT.CATEGORY.SITE_BUILDER_AI,
    action: EVENT.ACTION.CLICK_BUTTON_SHOW_PREVIEW,
    label: EVENT.LABEL.CREATE_FROM_A_READY_MADE_TEMPLATE,
  },
};

const clickCreateWithMyBusiness = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickCreateWithMyBusiness.campaign,
    gaEventAction: events.clickCreateWithMyBusiness.action,
    gaEventLabel: events.clickCreateWithMyBusiness.label,
  });
  collectTrackData(events.clickCreateWithMyBusiness);
};

const clickCreateWithYourIdeas = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickCreateWithYourIdeas.campaign,
    gaEventAction: events.clickCreateWithYourIdeas.action,
    gaEventLabel: events.clickCreateWithYourIdeas.label,
  });
  collectTrackData(events.clickCreateWithYourIdeas);
};

const clickCreateFromTemplate = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickCreateFromTemplate.campaign,
    gaEventAction: events.clickCreateFromTemplate.action,
    gaEventLabel: events.clickCreateFromTemplate.label,
  });
  collectTrackData(events.clickCreateFromTemplate);
};

const clickGoBackMethodSelection = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickGoBackMethodSelection.campaign,
    gaEventAction: events.clickGoBackMethodSelection.action,
    gaEventLabel: events.clickGoBackMethodSelection.label,
  });
  collectTrackData(events.clickGoBackMethodSelection);
};

const clickCreateMySite = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickCreateMySite.campaign,
    gaEventAction: events.clickCreateMySite.action,
    gaEventLabel: events.clickCreateMySite.label,
  });
  collectTrackData(events.clickCreateMySite);
};

const clickGoBackChooseAnotherOption = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickGoBackChooseAnotherOption.campaign,
    gaEventAction: events.clickGoBackChooseAnotherOption.action,
    gaEventLabel: events.clickGoBackChooseAnotherOption.label,
  });
  collectTrackData(events.clickGoBackChooseAnotherOption);
};

const clickGoBackCreateWithMyBusiness = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickGoBackCreateWithMyBusiness.campaign,
    gaEventAction: events.clickGoBackCreateWithMyBusiness.action,
    gaEventLabel: events.clickGoBackCreateWithMyBusiness.label,
  });
  collectTrackData(events.clickGoBackCreateWithMyBusiness);
};

const clickNextStepStep1 = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickNextStepStep1.campaign,
    gaEventAction: events.clickNextStepStep1.action,
    gaEventLabel: events.clickNextStepStep1.label,
  });
  collectTrackData(events.clickNextStepStep1);
};

const clickNextStepStep2 = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickNextStepStep2.campaign,
    gaEventAction: events.clickNextStepStep2.action,
    gaEventLabel: events.clickNextStepStep2.label,
  });
  collectTrackData(events.clickNextStepStep2);
};

const clickNextStepStep3 = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickNextStepStep3.campaign,
    gaEventAction: events.clickNextStepStep3.action,
    gaEventLabel: events.clickNextStepStep3.label,
  });
  collectTrackData(events.clickNextStepStep3);
};

const clickCreateWithThisTemplate = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickCreateWithThisTemplate.campaign,
    gaEventAction: events.clickCreateWithThisTemplate.action,
    gaEventLabel: events.clickCreateWithThisTemplate.label,
  });
  collectTrackData(events.clickCreateWithThisTemplate);
};

const clickIWantThisTemplate = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickIWantThisTemplate.campaign,
    gaEventAction: events.clickIWantThisTemplate.action,
    gaEventLabel: events.clickIWantThisTemplate.label,
  });
  collectTrackData(events.clickIWantThisTemplate);
};

const clickSearchForAnother = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickSearchForAnother.campaign,
    gaEventAction: events.clickSearchForAnother.action,
    gaEventLabel: events.clickSearchForAnother.label,
  });
  collectTrackData(events.clickSearchForAnother);
};

const clickShowPreview = () => {
  collect({
    event: EVENT.NAME,
    gaEventCategory: events.clickShowPreview.campaign,
    gaEventAction: events.clickShowPreview.action,
    gaEventLabel: events.clickShowPreview.label,
  });
  collectTrackData(events.clickShowPreview);
};

const analytics = {
  clickCreateWithMyBusiness,
  clickCreateWithYourIdeas,
  clickCreateFromTemplate,
  clickGoBackMethodSelection,
  clickCreateMySite,
  clickGoBackChooseAnotherOption,
  clickGoBackCreateWithMyBusiness,
  clickNextStepStep1,
  clickNextStepStep2,
  clickNextStepStep3,
  clickCreateWithThisTemplate,
  clickIWantThisTemplate,
  clickSearchForAnother,
  clickShowPreview,
};

export default analytics;
